import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { SelfAttendancePermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Self-attendance route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(SelfAttendancePermissions.access, Page, {
      mode: 'any',
      administratorBypass: true,
    }),
  }
}

/** Supervisor self-attendance review console. */
export const selfAttendanceRoutes: RouteObject[] = [
  {
    path: 'payroll/self-attendance',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/self-attendance-page'),
        'SelfAttendancePage',
      ),
  },
]
